// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-subtitle[data-v-172fb3c4]{font-weight:400;color:#666;margin-top:0;margin-bottom:.625rem;font-size:16px;line-height:1.1875rem}", ""]);
// Exports
module.exports = exports;
